import { NotifyHelper } from "../../../helpers/toast";
import { eDonHangActionTypeDefine } from "../../action-types/don-hang/IDonHangActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const donHangActions = {
    ...generateActions(eDonHangActionTypeDefine, "DON_HANG"),
    ...generateActionForKey(eDonHangActionTypeDefine, "DON_HANG", "LOAD_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eDonHangActionTypeDefine, "DON_HANG", "SEND_EMAIL_ERROR", (m) => { NotifyHelper.Error(m) }),
};
